import { Outlet, Link } from 'react-router-dom';
import { useSessionStore } from '../hooks/useSession';

export const Layout = () => {
  const { session } = useSessionStore();

  return (
    <div className="layout">
      <header className="header">
        <Link to="/" className="logo">SyncPlay</Link>
        <nav>
          {session && (
            <span className="status-indicator">
              <span className={`status-dot ${session.status === 'active' ? 'connected' : 'disconnected'}`} />
              {session.status === 'active' ? 'Connected' : 'Disconnected'}
            </span>
          )}
        </nav>
      </header>
      
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
};